import styled, {css} from 'styled-components';
import {Container as HeroContainer} from '../../../ui/Drops/components/Hero/Hero';
import {
  bordersColor,
  complementaryColor,
  darkGrayColor,
  primaryColor,
} from '../../../ui/constants/colors';
import {
  mediaMaxTablet,
  mediaMinTablet,
} from '../../../ui/constants/customMedia';
import {
  fontSize12,
  fontSize16,
  fontSize20,
  fontSize24,
  fsS,
  fsXL,
  fsXS,
  fsXXL,
  fwBold,
  fwHeavy,
  fwMediumBold,
  fwSemiBold,
  lhM,
} from '../../../ui/constants/typography';

export const OverviewPageContainer = styled.article`
  max-width: 1115px;
  margin: 0 auto;
  padding-left: 10px;
  padding-right: 10px;
`;

export const TeaserContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
`;

export const SectionSeparator = styled.div<{
  renderAsCard?: boolean;
}>`
  margin-top: 100px;
  margin-bottom: 30px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  position: relative;

  @media ${mediaMinTablet} {
    margin-top: 120px;
    margin-bottom: 47px;
  }

  ${({renderAsCard}) =>
    renderAsCard &&
    css`
      margin-top: 24px;
      margin-bottom: 24px;
      align-items: flex-start;
      margin-left: 14px;

      @media ${mediaMaxTablet} {
        &::before {
          position: absolute;
          width: calc(100% + 34px);
          top: -32px;
          left: -24px;
          height: 8px;
          background-color: ${bordersColor};
          content: '';
        }
      }
    `};

  &:first-of-type {
    margin-top: 34px;

    @media ${mediaMinTablet} {
      margin-top: 60px;
    }
  }

  & + ${HeroContainer} {
    margin-top: 0;
  }
`;

export const SeparatorCategory = styled.div`
  ${fontSize12};
  ${fwMediumBold};
  line-height: ${lhM};
  color: ${darkGrayColor};
  text-transform: uppercase;

  @media ${mediaMinTablet} {
    ${fontSize16};
    ${fwSemiBold}
  }
`;

export const SeparatorTitle = styled.div`
  ${fontSize20};
  ${fwSemiBold};
  line-height: 1.17;
  margin-top: 6px;

  @media ${mediaMinTablet} {
    ${fontSize24};
    ${fwHeavy};
    margin-top: 16px;
  }
`;

export const Headline = styled.div`
  font-size: ${fsXL}px;
  line-height: ${lhM};
  ${fwHeavy};

  @media ${mediaMinTablet} {
    font-size: ${fsXXL}px;
  }
`;

export const Subline = styled.div`
  font-size: ${fsXS}px;
  line-height: ${lhM};
  ${fwBold};

  @media ${mediaMinTablet} {
    font-size: ${fsS}px;
  }

  & + ${Headline} {
    margin-top: 8px;
  }
`;

export const HeadlineContainer = styled.div<{backgroundImageUrl: string}>`
  position: absolute;
  max-width: 80%;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  color: ${({backgroundImageUrl}) =>
    backgroundImageUrl.length > 0 ? complementaryColor : primaryColor};
  text-align: center;

  ${({backgroundImageUrl}) =>
    backgroundImageUrl.length === 0 &&
    css`
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      flex: 1 1 auto;
      position: relative;
      top: 0;
      left: 0;
      transform: translate(0, 0);
      max-width: 100%;
      border-bottom: 1px solid ${bordersColor};
    `};
`;
